module.exports = ".panel_toolbox {\r\n\tmin-width: unset;\r\n}"